import request from '@/utils/request';
import { collectionDatasetsEndpoint, collectionDatasetsManagementEndpoint } from '@/constants/urls';
import { isCommonsModeEnabled } from '@/auth/featureToggles';

const datasets = (
  code,
  filter,
  assignableFlag,
  privateFlag,
  internalFlag,
  publicFlag,
  page,
  pageSize,
  requestable,
  queryable,
  orderBy,
) => {
  const params = {
    filter,
    page,
    pageSize,
    orderBy,
  };

  if (requestable) {
    params.requestable = true;
  }

  if (queryable) {
    params.queryable = true;
  }

  if (isCommonsModeEnabled()) {
    const visibilityFlags = [privateFlag, internalFlag, publicFlag];
    const allSet = visibilityFlags.every((v) => v === visibilityFlags[0]);

    if (!allSet) {
      if (privateFlag) {
        params.private = true;
      }
      if (internalFlag) {
        params.internal = true;
      }
      if (publicFlag) {
        params.public = true;
      }
    }
  } else if (privateFlag !== internalFlag) {
    if (privateFlag) {
      params.private = true;
    }
    if (internalFlag) {
      params.internal = true;
    }
  }

  if (assignableFlag) {
    params.assignable = true;
    params.page = 1;
    params.pageSize = 20;
  }

  return request({
    url: collectionDatasetsEndpoint(code),
    params,
    method: 'GET',
  });
};

const addDataset = ({ code }, datasetCode) => request({
  url: collectionDatasetsManagementEndpoint(code, datasetCode),
  method: 'POST',
});

const removeDataset = ({ code }, datasetCode) => request({
  url: collectionDatasetsManagementEndpoint(code, datasetCode),
  method: 'DELETE',
});

const CollectionDatasetsService = {
  datasets,
  addDataset,
  removeDataset,
};

export default CollectionDatasetsService;
